<div *ngIf="showMessage" class="app-error">
	<div class="app-message textCenter">
		<p i18n class="text3xlrg">We’re sorry, this page is temporarily unavailable.</p>
		<p class="app-text-2 textxlrg">
			<span i18n >Try again later at</span>
			<button (click)="goToHomePage()" type="button" class="link">{{this.siteOrigin}}</button>
		</p>
	</div>
</div>
